"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ForgotPassword["default"];
  }
});
var _ForgotPassword = _interopRequireDefault(require("./ForgotPassword"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }